import styles from "./SurveyScreen.module.scss";

import { ReactNode } from "react";

import { SurveyFooter } from "@/modules/session-survey/components/SurveyFooter";
import { useOverflowDetection } from "@/modules/shared/hooks/useOverflowDetection";

interface SurveyStatusShellProps {
  children: ReactNode;
}

export const SurveyStatusShell = ({ children }: SurveyStatusShellProps) => {
  const { ref, hasOverflow } = useOverflowDetection<HTMLDivElement>();

  return (
    <div ref={ref} className={styles.container}>
      <div className={styles.centered}>{children}</div>
      <SurveyFooter hasOverflow={hasOverflow} />
    </div>
  );
};
